import React from 'react';
import { string } from 'prop-types';
import LockIcon from '../../images/lock-icon.svg';
import './SecurityNotice.scss';

// only used for copy refresh v2 - variant A
const SecurityNotice = props => (
  <div className="securityNotice">
    <img src={LockIcon} alt="Lock Icon" />
    <span>{props.text}</span>
  </div>
);

SecurityNotice.propTypes = {
  text: string.isRequired,
};

export default SecurityNotice;

